import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseHttpService } from '../base.httpservice';
import { UserStatistics } from '../../models/userstatistics';
import { HeadToHead } from '../../models/headtohead';
import { Rival } from '../../models/rival';
import { Rating } from '../../models/rating';
import { StraightCareerStats } from '../../models/straightcareerstats';
import { RecordStats } from '../../models/recordstats';

@Injectable()
export class StatisticsHttpService extends BaseHttpService {
	protected readonly endpoint = this.apiUrl('matches');

	constructor(http: HttpClient) {
		super(http);
	}

	getStatistics(userId: string): Observable<UserStatistics> {
		return this.http.get<UserStatistics>(`${this.endpoint}/statistics/${userId}`);
	}

	getHeadToHead(opponentId: string): Observable<HeadToHead> {
		return this.http.get<HeadToHead>(`${this.endpoint}/headtohead/${opponentId}`);
	}

	getTopRival(userId: string): Observable<Rival> {
		return this.http.get<Rival>(`${this.endpoint}/toprival/${userId}`);
	}

	getRivals(userId: string): Observable<Rival[]> {
		return this.http.get<Rival[]>(`${this.endpoint}/rivals/${userId}`);
	}

	getRating(userId: string): Observable<Rating> {
		return this.http.get<Rating>(`${this.endpoint}/rating/${userId}`);
	}

	getStraightStats(userId: string): Observable<StraightCareerStats> {
		return this.http.get<StraightCareerStats>(`${this.endpoint}/straightstats/${userId}`);
	}

	getRecords(userId: string): Observable<RecordStats> {
		return this.http.get<RecordStats>(`${this.endpoint}/records/${userId}`);
	}
}
